import './toggle-group.css';

import * as ToggleGroup from '@radix-ui/react-toggle-group';
import { cva, VariantProps } from 'class-variance-authority';
import React from 'react';

import { cn } from '@/services/utils';

const toggleVariants = cva(
    `toggle-group-item
     tw-shadow-none
     tw-border-none
     tw-bg-transparent
     tw-cursor-pointer
     tw-mr-1
     tw-p-2
     tw-inline-flex
     tw-items-center
     tw-justify-center
     tw-rounded-md
     tw-text-t-sm
     tw-font-medium
     tw-ring-offset-background
     tw-transition-colors
     hover:tw-bg-muted
     hover:tw-text-muted-foreground
     focus-visible:tw-outline-none
     focus-visible:tw-ring-2
     focus-visible:tw-ring-ring
     focus-visible:tw-ring-offset-2
     disabled:tw-pointer-events-none
     disabled:tw-opacity-50
     data-[state=on]:tw-bg-accent
     data-[state=on]:tw-text-accent-foreground`,
    {
        variants: {
            variant: {
                icon: 'toggle-group-item-icon',
            },
        }
    }
);

const ToggleGroupItem = React.forwardRef<
    React.ElementRef<typeof ToggleGroup.Item>,
    React.ComponentPropsWithoutRef<typeof ToggleGroup.Item> &
    VariantProps<typeof toggleVariants>
>(({ className, variant, ...props }, ref) => (
    <ToggleGroup.Item
        ref={ref}
        className={cn(toggleVariants({ variant, className }))}
        {...props}
    />
));

ToggleGroupItem.displayName = 'ToggleGroupItem';

export { ToggleGroupItem };
